.hoverArrow {
  display: flex;
  justify-content: flex-end;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  position: absolute;
  right: var(--tfg-organism-padding-x);
  bottom: var(--tfg-organism-padding-x);
  transform: none;
}

.container {
  cursor: pointer;
  display: flex;
  gap: var(--tfg-organism-gap-y);
  color: var(--mantine-color-text);
  flex-direction: column;
  justify-content: flex-start;
  border-radius: var(--tfg-card-border-radius);
  border: 1px solid var(--mantine-color-gray-2);
  padding: var(--tfg-organism-padding-x) var(--tfg-organism-padding-x);
  background-color: white;
  position: relative;
  &:hover {
    border: 1px solid var(--mantine-color-gray-3);
    .hoverArrow {
      opacity: 1;
    }
  }
}

.container:hover .text {
  text-overflow: ellipsis;

  color: var(--mantine-color-primary-4) !important;
}

.container:hover svg {
  stroke: var(--mantine-color-primary-4) !important;
}
